import React from 'react'
import Skeleton from 'react-loading-skeleton'

const SelectonEnrolldStudenetCourseCard = () => {
    return(
        <div className="row">
            <div className="col-lg-4">
                <div className="thumb">
                    <Skeleton
                        height="172px"
                        count={1}
                    />
                </div>
            </div>
            <div className="col-lg-8 align-self-center">
                <div className="content">
                    <h3>
                        <Skeleton
                            width={'80%'}
                            count={1}
                        />
                    </h3>
                    <p>
                        <Skeleton
                            width={'100%'}
                            count={2}
                        />
                        <br/>
                        <Skeleton
                            width={'80%'}
                            count={1}
                        />
                    </p>
                    <div className="details-rating">
                        <Skeleton
                            height="30px"
                            count={1}
                            width={'50%'}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SelectonEnrolldStudenetCourseCard;